import { createModel } from '@/store/tools';

const model = {
    namespace: 'accumulaterule',
    build: (T, A, S, R, C) => ({
        actiontypes: {
            'getAccumulateList': T('getAccumulateList'),
        },
        actions: {
            'getAccumulateList': A('getAccumulateList'), // 积分规则查询
        },
        sagas: {
            'getAccumulateList': S('getAccumulateList', '/?cmd=com.xqxc.api.pig.mis.biz.platform.AdminParamMisService.listAdminParamByParamType', 'POST'),
        },
        reducers: {
            'accumulateList': R('getAccumulateList', []),
        }
    })
};
export default createModel(model);